import {IRange} from "@pg-design/inputs-module";

import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const area: ISearchFilterSlot<"area", IRange<number>> = {
    id: "area",
    label: "Metraż",
    filters: [
        {
            id: "area",
            type: SearchFilterTypes.RANGE,
            filterOptions: []
        }
    ]
};
import {IRange} from "@pg-design/inputs-module";

import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const area: ISearchFilterSlot<"area", IRange<number>> = {
    id: "area",
    label: "Metraż",
    filters: [
        {
            id: "area",
            type: SearchFilterTypes.RANGE,
            filterOptions: []
        }
    ]
};
